import React, { useState } from "react";
import { motion } from "framer-motion";
import { images } from "../../constants";

import "./Menu.scss";

const Menu = () => {
  const [toggle, setToggle] = useState(false);
  let logo = "HORUSCHILD";
  return (
    <div className="app__navbar-menu">
      <h1 onClick={() => setToggle(true)} className="menu-btn">
        MENU
      </h1>

      {toggle && (
        <motion.div
          initial={{ x: 1000 }}
          animate={{ x: 0 }}
          transition={{ duration: 0.85, ease: "easeOut" }}
        >
          <div className="menu-header">
            <h1 className="menu-logo">{logo}</h1>
            <h1 className="close-btn" onClick={() => setToggle(false)}>
              close
            </h1>
          </div>
          <ul className="menu-list">
            <li>
              <a
                href="#header"
                data-text="HOME"
                onClick={() => setToggle(false)}
              >
                HOME
              </a>
            </li>
            <li>
              <a
                href="#about"
                data-text="ABOUT"
                onClick={() => setToggle(false)}
              >
                ABOUT
              </a>
            </li>
            <li>
              <a
                href="#work"
                data-text="*WORKS"
                onClick={() => setToggle(false)}
              >
                *WORKS
              </a>
            </li>
            <li>
              <a
                href="#footer"
                data-text="CONTACT"
                onClick={() => setToggle(false)}
              >
                CONTACT
              </a>
            </li>
            {/* {["home", "about", "skills", "project"].map((item) => (
              <li key={`link-${item}`}>
                <a
                  href={`#${item}`}
                  data-text={item}
                  onClick={() => setToggle(false)}
                >
                  {item}
                </a>
              </li>
            ))} */}
          </ul>
          <img src={images.coin} alt="" />
        </motion.div>
      )}
    </div>
  );
};

export default Menu;
